import { tns } from "tiny-slider/src/tiny-slider";
export default class RelatedProductsSlider {
    constructor(block) {
        this.sliderBlock = block;
        this.sliderContainer = this.sliderBlock.querySelector('.slider-wrapper');
        if (this.sliderContainer && this.sliderContainer.childElementCount >= 2) {
            // If 2 or more images - set slider active
            this.sliderControlsWrapper = this.sliderBlock.querySelector('.related-products-slider-controls');
            this.slidesPerDevice = this.sliderContainer.attributes.getNamedItem('data-slides').value;
            // split string into array
            // desktop, mobile
            this.slidesPerDevice = this.slidesPerDevice.split(',');
            this.init();
        }
    }
    init() {
        let desktopGutter = 24;
        let mobileGutter = 24;
        if (parseInt(this.slidesPerDevice[0]) >= 2) {
            desktopGutter = 24;
        }
        if (parseInt(this.slidesPerDevice[1]) >= 2) {
            mobileGutter = 24;
        }
        const slider = tns({
            container: this.sliderContainer,
            items: this.slidesPerDevice[1], // mobile count
            gutter: mobileGutter,
            slideBy: 1,
            loop: true,
            autoplay: false,
            controls: true,
            nav: false,
            navPosition: 'bottom',
            mouseDrag: true,
            swipeAngle: false,
            speed: 400,
            // @ts-ignore
            prevButton: this.sliderControlsWrapper.querySelector('.previous-slide'),
            // @ts-ignore
            nextButton: this.sliderControlsWrapper.querySelector('.next-slide'),
            responsive: {
                500: {
                    items: 2.3, // desktop count
                    gutter: desktopGutter,
                },
                992: {
                    items: this.slidesPerDevice[0], // desktop count
                    gutter: desktopGutter,
                }
            },
        });
    }
}
